import ScheduleService from "../../services/schedule.service";
import { createUrl } from "../../http";

const state = {
  flightList: [],
  changeFlightListId: [],
  newFlight: [],
  DailyFlightCount: [],
  SearchDate: "",
  timeSpan: 0,
  attachmentsFlight: [],
  deleteAttachments: [],
  idOfPdf: 0,
  openShowFileCount: 0,
  isActiveFileUpload: false,
  isActiveFlightNote: false,
  isActiveFlightNotify: false,
  isActiveEFBReportModal: false,
  FlightNoteList: [],
  FlightNoteDetails: [],

  activeFKey: null,
  activeFkeyForZip: null,
  activeFlightData: null,

  activeFlightBasedReportFiles: null,

  activeStd: null,
  activeLegNo: null,

  files: null,
  deleteAttachment: 0,
  returnMessage: null,
  flightMessage: null,
  isActiveShowFile: false,
  activeArchiveId: 0,
  activePdfUrl: createUrl("/Attachment/get/"),
  releaseModalUrl: createUrl("/Attachment/GetFlightReleaseByFlight/"), // 'https://localhost:44333/api/Attachment/GetFlightReleaseByFlight/'
  notamModalUrl: createUrl("/Attachment/GetNotamByFlight/"), // 'https://localhost:44333/api/Attachment/GetNotamByFlight/'
  meteoModalUrl: createUrl("/Attachment/GetMeteoByFlight/"), // 'https://localhost:44333/api/Attachment/GetMeteoByFlight/'
  weatherModalUrl: createUrl("/Attachment/GetWeatherchart/"), // 'https://localhost:44333/api/Attachment/GetWeatherchart/'
  reportModalUrl: createUrl("/Report/Get/"),
  reportPdfModalUrl: createUrl("/Report/ShowPdf/"),
  reportImageModalUrl: createUrl("/Report/ShowImage/"),
  weatherWebModalUrl: createUrl("/Attachment/GetWeatherWebByFlight/"), // 'https://localhost:44333/api/Attachment/GetWeatherWebByFlight/'

  S_WRjsonData: null,
  S_WNReqJetP_Data: null,
  jsonData: [],
  DbUtcDT: null,
  attachmentTypesState: [
    { text: "Other", value: 0, stat: 2 }, // her durumda kullanılır.
    { text: "Weather Chart", value: 9, stat: 0 },
    { text: "Notam", value: 13, stat: 0 },
    { text: "Weather", value: 14, stat: 0 },
    { text: "Raim Prediction", value: 15, stat: 0 },
  ], // bunu sonra silebilirsin.
  FlightofattachmentTypesState: [],

  rolelist: [],
  userlist: [],
  userlistByRole: [],
  selectedRelatedUserAttachmentUpl: null,
  selectedRole: null,

  //Pdf Upload and Show Finish
};

const mutations = {
  set_flight_list(state, payload) {
    // console.log(payload)
    state.flightList = payload;
  },

  clear_flight_list(state) {
    state.flightList = [];
  },

  set_user_list(state, payload) {
    state.userlist = payload;
  },

  clear_user_list(state) {
    state.userlist = [];
  },

  set_role_list(state, payload) {
    state.rolelist = payload;
  },

  clear_role_list(state) {
    state.rolelist = [];
  },

  set_timeSpan(state, payload) {
    state.timeSpan = payload;
    // console.log(payload);
  },

  set_DbDTutc(state, payload) {
    state.DbUtcDT = payload;
  },

  set_flight_change_list(state, payload) {
    state.changeFlightListId = [];
    state.flightList.forEach((oldFligth) => {
      state.newFlight = payload.find(
        (flight) => flight.fKeyForZip == oldFligth.fKeyForZip
      ); // fKey1
      const jsonOld = JSON.stringify(oldFligth);
      const jsonNew = JSON.stringify(state.newFlight);
      if (jsonOld != jsonNew) {
        // console.log(oldFligth.fKeyForZip + 'Nolu kayıt Değişti.')
        // alert("değişiklik var alert, ");
        state.flightMessage =
          oldFligth.fKeyForZip + " Nolu kayıtta değişiklik var kontrol ediniz.";
        state.changeFlightListId.push(oldFligth.fKeyForZip);
      }
      // state.flightList = payload;
    });

    state.flightList = payload;
  },

  // set_dailyFlightCount(state, payload) {
  //     state.DailyFlightCount = payload
  // },

  set_Search_Date(state, payload) {
    state.SearchDate = payload;
  },

  set_Attachments_Flight(state, payload) {
    if (payload.length) {
      state.attachmentsFlight = payload;
      state.idOfPdf = payload[0].id;
    } else {
      state.attachmentsFlight = [];
    }

    state.openShowFileCount = payload.length;
  },

  set_AttachmentTypeState(state, payload) {
    state.attachmentTypesState[1].stat = payload.notamWeb;
    state.attachmentTypesState[2].stat = payload.weather;
    state.attachmentTypesState[3].stat = payload.weatherWeb;
    state.attachmentTypesState[4].stat = payload.raimPrediction;
    state.FlightofattachmentTypesState = state.attachmentTypesState;
  },

  set_Open_Upload_Modal(state) {
    state.isActiveFileUpload = true;
  },

  set_Open_FlightNote_Modal(state) {
    state.isActiveFlightNote = true;
  },

  SHOW_FLIGHT_NOTIFY_MODAL(state) {
    state.isActiveFlightNotify = true;
  },
  CLOSE_FLIGHT_NOTIFY_MODAL(state) {
    state.isActiveFlightNotify = false;
  },

  set_Open_Report_Modal(state) {
    state.isActiveEFBReportModal = true;
  },

  set_Open_Document_Show_Modal(state) {
    state.isActiveShowFile = true;
    state.activePdfUrl = createUrl("/Attachment/get/");
  },

  set_ActiveNetline_Id(state, payload) {
    state.activeFKey = payload;
  },

  set_ActiveLegNo(state, payload) {
    state.activeLegNo = payload;
  },

  set_ActiveFlightItem(state, payload) {
    state.activeFlightData = payload;
  },

  set_FlightBasedReportFiles(state, payload) {
    state.activeFlightBasedReportFiles = payload;
  },

  set_ActiveKeyForZipForAttachment(state, payload) {
    state.activeFkeyForZip = payload;
  },

  set_ActiveArchiveIdForAttachment(state, payload) {
    state.ActiveArchiveId = payload;
  },

  set_ActiveStdForAttachment(state, payload) {
    state.activeStd = payload;
  },

  set_Close_File_Upload(state) {
    state.isActiveFileUpload = false;
    state.isActiveShowFile = false;
  },

  set_Close_FlightNote(state) {
    state.isActiveFlightNote = false;
    state.FlightNoteList = [];
    state.FlightNoteDetails = [];
  },

  set_Close_EFBReportModal(state) {
    state.isActiveEFBReportModal = false;

    // ilgili listelerin boşaltılması işleminin alınması ...
  },

  set_flightNotesByLegNo(state, payload) {
    if (payload == "" || payload == null) {
      state.FlightNoteList = payload;
      state.FlightNoteDetails = "";
      return;
    }

    state.FlightNoteList = payload;
    state.FlightNoteDetails = JSON.parse(
      state.FlightNoteList.filter((x) => x.ntype == "T")[0].message
    );
  },

  set_Close_File_Show_Modal(state) {
    state.isActiveShowFile = false;
  },

  set_File_Change(state, payload) {
    state.files = payload[0];
  },

  set_Delete_Attachmnet(state, payload) {
    state.deleteAttachment = payload;
  },

  set_Clear_File(state) {
    state.files = null;
  },

  set_Message(state, payload) {
    state.returnMessage = payload.data;
  },

  set_File_Document_Modal(state, payload) {
    state.idOfPdf = payload.data[0].id;
  },

  set_Flight_Release_Modal(state, payload) {
    state.activePdfUrl = state.releaseModalUrl;
    state.idOfPdf = payload;
    state.isActiveShowFile = true;
  },

  set_Notam_Modal(state, payload) {
    state.activePdfUrl = state.notamModalUrl;
    state.idOfPdf = payload;
    state.isActiveShowFile = true;
  },

  set_Meteo_Modal(state, payload) {
    state.activePdfUrl = state.meteoModalUrl;
    state.idOfPdf = payload;
    state.isActiveShowFile = true;
  },

  set_updateIdOfPdf(state, payload) {
    state.idOfPdf = payload;
  },

  set_Delete_Attachments(state, payload) {
    state.deleteAttachments = payload;
  },

  set_attachment_view(state, payload) {
    state.attachmentView = payload;
    payload.forEach((item) =>
      state.jeppesenAttachmentView.push(item.flightKey)
    );
  },

  set_WRjson_data(state, payload) {
    state.S_WRjsonData = payload;
  },

  set_WNReqJetP_Data(state, payload) {
    state.S_WNReqJetP_Data = payload;
  },

  set_json_data(state, payload) {
    state.jsonData = payload;
  },
};
const actions = {
  async setSearchValueData({ commit }, payload) {
    commit("set_Search_Date", payload);
  },

  async setUploadFiles({ commit }, payload) {
    commit("set_File_Change", payload);
  },

  async setClearUploadFile({ commit }) {
    commit("set_Clear_File");
  },

  async getScheduleFlights({ commit }) {
    await commit("clear_flight_list");
    var schedule = await ScheduleService.getScheduleFlights(state.SearchDate);
    schedule.sort((a, b) => (a.std < b.std ? 1 : -1)); // bu kısmı test ederek silebilirsin ... sort order kullanımı ile testini gerçekleştirmelisin
    await commit("set_flight_list", schedule);
    //dispatch("getDailyFlightSummary");
    return schedule;
  },

  async getAllUsers({ commit }) {
    await commit("clear_user_list");
    var users = await ScheduleService.getAllUsers();
    await commit("set_user_list", users);
    return users;
  },

  async getAllRoles({ commit }) {
    await commit("clear_role_list");
    var roles = await ScheduleService.getAllRoles();
    await commit("set_role_list", roles);
    return roles;
  },

  async clearScheduleFlights({ commit }) {
    await commit("clear_flight_list");
  },

  async getScheduleChangeFlights({ commit }) {
    const timeSpan = await ScheduleService.getFlightsTimeSpan(state.SearchDate);

    if (typeof timeSpan.dTutc !== "undefined") {
      commit("set_DbDTutc", timeSpan.dTutc);
    }

    if (timeSpan.count != state.timeSpan) {
      // alert(" new timespan"+timeSpan.count +" old timespan"+ state.timeSpan)
      commit("set_timeSpan", timeSpan.count);

      const schedule = await ScheduleService.getScheduleFlights(
        state.SearchDate,
      );

      await commit("set_flight_change_list", schedule);

      return schedule;
    }
  },

  async ForceUpdateNetlineIntegrationModule() {
    const resp = await ScheduleService.ForceUpdateNetlineIntegrationService();
    return resp;
  },

  async showUploadModalV2(
    { commit, dispatch },
    { FKeyForZip, FKeyForNetline, Std, postflight }
  ) {
    const getAttachmentsByFlight = await ScheduleService.getAttachmentByFlights(
      FKeyForNetline
    );

    await commit("set_AttachmentTypeState", postflight);
    await commit("set_Attachments_Flight", getAttachmentsByFlight);
    await dispatch("getAllRoles");
    await dispatch("getAllUsers");

    // this.selectedRelatedUserAttachmentUpl = this.userlist[0];

    await commit("set_Open_Upload_Modal");
    await commit("set_ActiveNetline_Id", FKeyForNetline);
    await commit("set_ActiveKeyForZipForAttachment", FKeyForZip);
    await commit("set_ActiveStdForAttachment", Std);
    await commit(
      "set_ActiveArchiveIdForAttachment",
      postflight.flightArchiveId
    );

    await dispatch("getDeleteAttachments", FKeyForNetline);

    return getAttachmentsByFlight;
  },

  async showFlightNoteModal({ commit }, { FKeyForZip, FKeyForNetline, LegNo }) {
    commit("set_ActiveNetline_Id", FKeyForNetline);
    commit("set_ActiveKeyForZipForAttachment", FKeyForZip);
    commit("set_ActiveLegNo", LegNo);

    commit("set_Open_FlightNote_Modal");
  },

  showFlightNotifyModal({ commit }, { FKeyForZip, FKeyForNetline, LegNo }) {
    commit("set_ActiveNetline_Id", FKeyForNetline);
    commit("set_ActiveKeyForZipForAttachment", FKeyForZip);
    commit("set_ActiveLegNo", LegNo);
    commit("SHOW_FLIGHT_NOTIFY_MODAL");
  },
  closeFlightNotifyModal({ commit }) {
    commit("CLOSE_FLIGHT_NOTIFY_MODAL");
  },

  async showEFBReportModal({ commit }, { FKeyForZip, LegNo, FlightItem }) {
    commit("set_ActiveKeyForZipForAttachment", FKeyForZip);
    commit("set_ActiveLegNo", LegNo);
    commit("set_ActiveFlightItem", FlightItem);

    commit("set_Open_Report_Modal");
  },

  async closeEFBReportModal({ commit }) {
    commit("set_Close_EFBReportModal");
  },

  async GetFlightNotes({ commit, state }) {
    const flightNotes = await ScheduleService.getFlightNotesByLegNo(
      state.activeLegNo
    );
    commit("set_flightNotesByLegNo", flightNotes);
    return flightNotes;
  },

  // async AddFligtNote({flightNoteForm})
  // {
  //   const responsemessage = await ScheduleService.InsertFlightNoteForm(flightNoteForm);
  //   return responsemessage.data;
  // },

  // async DeleteFlightNote({flightNoteForm})
  // {
  //     const responsemessage = await ScheduleService.DeleteFlightNoteForm(flightNoteForm);
  //     return responsemessage;
  // },

  async closeUploadModal({ commit }) {
    commit("set_Clear_File");
    commit("set_Close_File_Upload");
  },

  async closeFileModal({ commit }) {
    commit("set_Close_File_Show_Modal");
  },

  async closeFlightNoteModal({ commit }) {
    commit("set_Close_FlightNote");
  },

  async getAttachmentByFlights({ commit, state }) {
    const getAttachments = await ScheduleService.getAttachmentByFlights(
      state.activeFKey
    );
    commit("set_Attachments_Flight", getAttachments);
    return getAttachments;
  },

  async fileUploadxxx({ commit, state }) {
    // console.log(state.activeFKey);
    var upload = await ScheduleService.setFileUpload(
      state.files,
      state.activeFKey
    );
    commit("set_Message", upload);
    commit("set_Clear_File");
    return upload;
  },

  async getDeleteAttachments({ commit, state }) {
    var deleteAttachments = await ScheduleService.getDeleteAttachments(
      state.activeFKey
    );
    commit("set_Delete_Attachments", deleteAttachments);
    return deleteAttachments;
  },

  async deleteDocumentV2(
    { commit },
    { AttachmentId, KeyForNetline, RealName, AttachmentTypeId, DeleteBy }
  ) {
    commit("set_Delete_Attachmnet", AttachmentId);
    const deleteDocument = await ScheduleService.deleteDocument(
      AttachmentId,
      KeyForNetline,
      RealName,
      AttachmentTypeId,
      DeleteBy
    );
    commit("set_Message", deleteDocument);
    commit("set_Clear_File");
    return deleteDocument;
  },

  async showDocumentFileModal({ commit }, payload) {
    const getAttachmentsByFlight = await ScheduleService.getAttachmentByFlights(
      payload
    );
    commit("set_Attachments_Flight", getAttachmentsByFlight);
    commit("set_ActiveNetline_Id", payload);
    commit("set_Open_Document_Show_Modal");
    return getAttachmentsByFlight;
  },

  async showFlightReleaseModal({ commit }, payload) {
    commit("set_Flight_Release_Modal", payload);
  },

  async showNotamModal({ commit }, payload) {
    commit("set_Notam_Modal", payload);
  },

  async showMeteoModal({ commit }, payload) {
    commit("set_Meteo_Modal", payload);
  },

  //async showSelectedAdditionalDocument({commit}, {state}, {payload})
  async showSelectedAdditionalDocument({ commit, state }, payload) {
    //alert('showSelectedAdditionalDocument'+payload)
    console.log("module");
    const getAttachmentsByFlight = await ScheduleService.getAttachmentByFlights(
      state.activeFKey
    );
    commit("set_Attachments_Flight", getAttachmentsByFlight);
    commit("set_updateIdOfPdf", payload);
    //commit("set_ActiveArchiveIdForAttachment",ArchiveStat);
    commit("set_Open_Document_Show_Modal");
    return getAttachmentsByFlight;
  },

  async updateIdOfPdf({ commit }, payload) {
    commit("set_updateIdOfPdf", payload);
  },

  async revertAttachment({ commit }, payload) {
    const revert = await ScheduleService.revertAttachment(payload);
    commit("set_Message", revert);
    return revert;
  },

  // archive stat
  async GetWRjson({ commit }, { KFZ, STD, WLVT, flightArchiveStat }) {
    const WRjsonData = await ScheduleService.GetWrJson(
      KFZ,
      STD,
      WLVT,
      flightArchiveStat
    );
    commit("set_WRjson_data", WRjsonData);
    return WRjsonData;
  },

  async GetWeatherNotamRequestJetPData(
    { commit },
    { KFZ, STD, WLVT, flightArchiveStat }
  ) {
    const WRjsonData = await ScheduleService.GetWNReqJetPDataService(
      KFZ,
      STD,
      WLVT,
      flightArchiveStat
    );
    commit("set_WNReqJetP_Data", WRjsonData);
    return WRjsonData;
  },

  // archive stat   bu fonksiyon schedule ekranında kullanılmıyor.
  async GetEffJson({ commit }, { KFZ, STD, JLVT, flightArchiveStat }) {
    //console.log("get eff json module");
    const EffjsonData = await ScheduleService.GetEffJson(
      KFZ,
      STD,
      JLVT,
      flightArchiveStat
    );
    commit("set_EFFjson_data", EffjsonData);
    return EffjsonData;
  },

  /// REPORT FUNCTIONS

  async GetEFBReportFiles({ commit }, { KFZ, STD, ArchiveId }) {
    // alert("MODULE MODULE"+KFZ+STD+DeviceUID)
    //alert(KFZ+STD+"GetEFBReportFiles schedule module GetEFBReportFiles")
    const resJsondata = await ScheduleService.GetEFBReportFilesByflight(
      KFZ,
      STD,
      ArchiveId
    );
    commit("set_FlightBasedReportFiles", resJsondata);
    return resJsondata;
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
